import {RaEvent, RaEventType} from "./RaEvent";
import {Timer} from "../services/configuration/timer.service";
import {TimerTiming} from "../services/configuration/timer.config";

export enum ACTIVITY_STATUS {
    activity_start,
    activity_end,
    one_time_activity,
    modal_open,
    modal_close
}

export class ActivityEventData {

    public type: string;
    public timer: Timer;
    public timing: TimerTiming;
    public word: any;
    public visualOnly: boolean; // glossary activity flag
    public hideCloseButton: boolean; // glossary activity flag
    public audio: string;
    public message: string;
    public storyUniqName:string;
    public automatic: boolean;
    public fluencyGoal: number;
    public storyLoaded: boolean;
    public coverImage?: string;

    constructor(public data: any = {}) {
        this.type = data.type || undefined;
        this.timer = data.timer || undefined;
        this.timing = data.timing || undefined;
        this.word = data.word || undefined;
        this.audio = data.audio || undefined;
        this.message = data.message || undefined;
        this.automatic = data.automatic || undefined;
        this.visualOnly = data.visualOnly || false;
        this.fluencyGoal = data.fluencyGoal || undefined;
        this.hideCloseButton = data.hideCloseButton || false;
        this.storyLoaded = data.storyLoaded || undefined;
        this.coverImage = data.coverImage || undefined;
    }

}

export class ActivityEvent extends RaEvent {

    static TYPE: RaEventType = "activity_event";

    constructor(private _status: ACTIVITY_STATUS, private _data: ActivityEventData = undefined) {
        super(ActivityEvent.TYPE);
    }

    public get status(): ACTIVITY_STATUS {
        return this._status;
    }

    public get type(): RaEventType {
        return ActivityEvent.TYPE;
    }

    public get data(): ActivityEventData {
        return this._data;
    }
}

export class ReportingActivityEvent extends ActivityEvent {

    constructor(private _reportingStatus: ACTIVITY_STATUS, private _reportingData: ReportEventData = undefined) {
        super(_reportingStatus, _reportingData);
    }

    public isAutomatic(): boolean {
        return this._reportingData.isAutomatic();
    }
}

export class ActivityModalEvent extends RaEvent {

    static TYPE: RaEventType = "activity_modal_event";

    constructor(private _status: ACTIVITY_STATUS, private _data: ActivityEventData = undefined) {
        super(ActivityModalEvent.TYPE);
    }

    public get status(): ACTIVITY_STATUS {
        return this._status;
    }

    public get type(): RaEventType {
        return ActivityModalEvent.TYPE;
    }

    public get data(): ActivityEventData {
        return this._data;
    }

}

export class MessageEventData extends ActivityEventData {

    constructor (data:{type:string, message?:string, timer?: Timer}) {
        super(data);
    }
}

export class ReportEventData extends ActivityEventData {

    public storyUniqName: string;
    public automatic: boolean;
    public fluencyGoal: number;
    public storyLoaded: boolean;

    constructor (data:{storyUniqName:string, type:string, automatic:boolean, fluencyGoal?: number, storyLoaded: boolean, coverImage?: string}) {
        super(data);
        this.storyUniqName = data.storyUniqName;
        this.automatic = data.automatic;
        this.fluencyGoal = data.fluencyGoal;
        this.storyLoaded = data.storyLoaded;
        this.coverImage = data.coverImage;
    }

    public isAutomatic(): boolean {
        return this.automatic;
    }
}
